import { createSlice } from '@reduxjs/toolkit';
import { setLocalStorage } from '../../utils';
import { AUTH_TOKEN } from '../../data/local-storage-constants';

export interface AuthState {
  userDetails: {};
  currentAuthStep: string;
  isLoading: Boolean;
  tokenData: {};
}

const initialState: AuthState = {
  userDetails: {},
  currentAuthStep: '',
  isLoading: false,
  tokenData: {},
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    triggerOTP: (state, actions) => {},
    validateOTP: (state, actions) => {},
    saveUserData: (state, action) => {
      state.userDetails = { ...action.payload };
    },
    updateAuthView: (state, action) => {
      state.currentAuthStep = action.payload.currentStep;
    },
    updateLoadingState: (state, action) => {
      state.isLoading = action.payload.loaderState;
    },
    saveToken: (state, action) => {
      action.payload.token && setLocalStorage(AUTH_TOKEN, action.payload.token);
      state.tokenData = { ...state.tokenData, ...action.payload };
    },
    logout: (state) => {
      state.userDetails = {};
      state.currentAuthStep = 'userDetails';
      state.tokenData = {};
    },
    logoutUser: (state, actions) => {},
  },
});

export const {
  saveUserData,
  updateAuthView,
  triggerOTP,
  validateOTP,
  updateLoadingState,
  saveToken,
  logout,
  logoutUser,
} = authSlice.actions;
export default authSlice.reducer;
